import type { RouteObject } from 'react-router';

import { peopleDetailRoute } from './detail/people-detail.route';
import { peopleRoute } from './index/people.route';

/**
 * The credited-person register and one person's page — `.routes.tsx` plural,
 * because the feature exports more than one `RouteObject`.
 *
 * Both sit inside the console layout route and inherit its guard chain. The
 * register is the only entry into the detail: the sitemap carries no
 * `/people/new`, which is why creating is a dialog and editing is a page.
 */
export const peopleRoutes: RouteObject[] = [peopleRoute, peopleDetailRoute];
